import { request } from 'meinian-package/src/utils'
import Button from 'meinian-package/src/baseComponent/button'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import Icon from 'meinian-package/src/component/icon'

export const setSampleComplete = async (addSampleInfo, setSampleData) => {
  const res = await request.spost('/zhikuan/mn/sample/upgrade-sample-info', addSampleInfo)
  const { successList } = res
  if (successList.length > 0) {
    const lastestSample = successList?.[0]
    setSampleData?.(false)
    ModalConfirm.show({
      title: '已生成样衣',
      icon: <Icon style={{ color: 'var(--m-success-normal)' }} type="m-xiaoyan_tianchong" />,
      content: lastestSample.name,
      hiddenCloseIcon: false,
      footer: <>
        <a href="/meinian/home/sample" target="_blank">
          <Button type="normal">样衣管理</Button>
        </a>
        <a href={`/meinian/detail/sample/image?sampleCode=${lastestSample?.sampleCode}`} target="_blank" rel="noreferrer" style={{ marginLeft: 8 }}>
          <Button type="normal">查看样衣</Button>
        </a>
      </>
    })
  } else {
    ModalConfirm.show({
      title: '样衣生成失败',
      icon: <Icon style={{ color: '#FA8B16' }} type="m-jinggao" />,
      content: '样衣生成失败，请重试或联系客服反馈',
      hiddenCancel: true
    })
  }
}
